import React from "react";
import { Flex } from "../styles/GlobalStyle";
import { css } from "@emotion/core";
import PulseLoader from "react-spinners/PulseLoader";
import ClipLoader from "react-spinners/ClipLoader";
import Property from "../model/property";

const LoadingIcon = (props) => {
  const preset = Property.getPreset();
  if (props.loadingState) {
    return (
      <Flex>
        <PulseLoader
          css={override}
          size={20}
          color={`${preset.app_loading_icon_color}`}
          loading={true}
        />
      </Flex>
    );
  } else {
    return null;
  }
};

export const ClipLoaderIcon = (props) => {
  const preset = Property.getPreset();
  if (props.loadingState) {
    return (
      <Flex>
        <ClipLoader
          css={override}
          size={props.size || 20}
          color={`${props.color || preset.app_loading_icon_color}`}
          loading={true}
        />
      </Flex>
    );
  } else {
    return null;
  }
};

export default LoadingIcon;

const override = css`
  display: block;
  margin: 5;
  border-color: red;
`;
